import { connect } from "react-redux";

import Renderer from "./Renderer";

const mapStateToProps = (state, ownProps) => ({
  features: state.features,
  ...ownProps
});

export default connect(
  mapStateToProps,
  null
)(Renderer);
